import { DELETE_PAYMENT_METHOD_ERROR_CODE, PAYMENT_METHOD_BUSINESS_ERROR_CODE, VALIDATION_ERROR_CODE } from '../const/errorCode';
import { CHECKING, SAVINGS } from '../const/paymentMedium';
import { t } from '../strings/i18n';
export const getPaymentTypeError = (errorMessage) => {
    switch (errorMessage) {
        case t('errors.checkingPaymentMethodInvalid'):
            return CHECKING;
        case t('errors.savingsPaymentMethodInvalid'):
            return SAVINGS;
        default:
            return null;
    }
};
export const getPaymentMethodErrorMessage = (businessErrorCode, paymentMethodType) => {
    /*
     * This ternary is a way for make it easier to future developers searching on a variable
     * We can't make it dynamically because we need to return a string instead of a function
     */
    const paymentMethodInvalid = paymentMethodType === CHECKING
        ? 'checkingPaymentMethodInvalid'
        : 'savingsPaymentMethodInvalid';
    const getPaymentMethodBusinessError = {
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_EXIST]: t('errors.paymentMethodExist'),
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_TYPE_INVALID]: t(`errors.${paymentMethodInvalid}`),
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_INVALID]: t('errors.paymentMethodAccountInvalid'),
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_INVALID]: t('errors.paymentMethodAccountInvalid'),
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_FAILED]: t('errors.paymentMethodAccountLocked'),
        [PAYMENT_METHOD_BUSINESS_ERROR_CODE.PAYMENT_METHOD_ACCOUNT_LOCKED]: t('errors.paymentMethodAccountLocked'),
        [DELETE_PAYMENT_METHOD_ERROR_CODE.PAYMENT_METHOD_AUTOPAY_EXISTS]: t('errors.autopayPaymentMethodError'),
        [DELETE_PAYMENT_METHOD_ERROR_CODE.PAYMENT_METHOD_PAYMENT_SCHEDULED]: t('errors.pendingPaymentMethodError')
    };
    return getPaymentMethodBusinessError[businessErrorCode] || '';
};
export const getErrorMessage = async (response, paymentMethodType) => {
    const validationError = response.status === VALIDATION_ERROR_CODE;
    const body = await response.json();
    const { businessErrors } = body;
    const [businessError] = businessErrors || [];
    if (validationError) {
        return getPaymentMethodErrorMessage(businessError === null || businessError === void 0 ? void 0 : businessError.code, paymentMethodType);
    }
    return t('errors.systemError');
};
